module.exports = __webpack_public_path__ + "frontend/img/operationalTransferability.d9118690.svg";